import * as axios from "axios";
import * as R from "ramda";
import * as ActionTypes from "../../constants/actiontypes/funecap/selfcare";
import * as urls from "../../constants/webapi/funecap/selfcare";
import { getAuthenticationUrl } from "../../constants/webapi/auth";

export function fetchSelfcareFiles(pageNumber, search, sortBy, sortDesc, operatorId = "", fromMeetingDate = "", toMeetingDate = "") {
	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && isNaN(page)) {
		throw new Error("pageNumber must be null or an integer");
	}

	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_SELFCARE_FILES_REQUEST });
		return axios
			.get(urls.selfcareFilesUrl(pageNumber, search, sortBy, sortDesc, operatorId, fromMeetingDate, toMeetingDate))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_SELFCARE_FILES_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_SELFCARE_FILES_FAILURE,
					response: error.response,
				});
				throw error.statusText;
			});
	};
}

export function UpdateOperator(id, operatorId) {
	return (dispatch) => {
		dispatch({ type: ActionTypes.UPDATE_OPERATOR_REQUEST });
		return axios
			.patch(urls.selfcareFileByIdUrl(id), { operatorId: operatorId })
			.then((response) => {
				dispatch({
					type: ActionTypes.UPDATE_OPERATOR_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.UPDATE_OPERATOR_FAILURE,
					response: error.response,
				});
				throw error.statusText;
			});
	};
}
